// extracted by mini-css-extract-plugin
export default {"page":"ConfirmPage_page__yhGDc","title":"ConfirmPage_title__+ogzR"};